import { render, staticRenderFns } from "./questionnaire_statistics.vue?vue&type=template&id=08f1c61a&scoped=true&"
import script from "./questionnaire_statistics.vue?vue&type=script&lang=js&"
export * from "./questionnaire_statistics.vue?vue&type=script&lang=js&"
import style0 from "./questionnaire_statistics.vue?vue&type=style&index=0&id=08f1c61a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f1c61a",
  null
  
)

export default component.exports